module.exports = __webpack_public_path__ + "img/pingtai1.50733014.png";